/* app/js/src/components/recording/recording-scheduler/recording-job-actions/recording-job-actions.component.scss */
.container {
  display: flex;
  justify-content: space-evenly;
}
.container .button {
  width: 58px;
  height: 28px;
  border-radius: 4px;
  background-color: #232f3a;
  cursor: pointer;
  transition: all 0.2s ease;
}
.container .button span {
  width: 33px;
  height: 12px;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.1px;
  color: #ffffff;
  position: relative;
  left: 14px;
  bottom: 7px;
}
.container .icon {
  width: 20px;
  cursor: pointer;
  height: 20px;
}
.container .icon.recording {
  padding-top: 2px;
}
.container .icon.delete ::ng-deep svg path,
.container .icon.delete ::ng-deep svg rect {
  fill: #757575;
}
/*# sourceMappingURL=recording-job-actions.component.css.map */
